import { useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useCsrfToken = () => {
  return useQuery({
    queryKey: ['csrf_token'],
    queryFn: () => _a.csrfToken(),
  });
};
